import { StateEffect, StateField } from '@codemirror/state';
import { Decoration, EditorView } from '@codemirror/view';

export const lineHighlightDeco = Decoration.line({
  class: 'line-highlight',
});

export const addLineHighlight = StateEffect.define<number>();

export const lineHighlightField = () => [
  StateField.define({
    create() {
      return Decoration.none;
    },
    update(lines, tr) {
      let l = lines.map(tr.changes);
      tr.effects.forEach((e) => {
        if (e.is(addLineHighlight)) {
          // l = Decoration.none;  NOTE: For single line highlight
          l = l.update({ add: [lineHighlightDeco.range(e.value)] });
        }
      });
      return l;
    },
    provide: (f) => EditorView.decorations.from(f),
  }),
];
